module.exports = "<electra-sub-page-header \t[text]=\"'Terms and Conditions'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t(close)=\"closeClick()\">\n</electra-sub-page-header>\n<img \t[ngClass]=\"config.image.length === 0 ? 'hide' : ''\"\n\t\t\t[src]=\"config.image\"/>\n<div \tid=\"terms-content\"\n\t\t\t[ngClass]=\"config.image.length > 0 ? 'lower' : ''\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/terms/terms.component.html
// module id = 438
// module chunks = 1